/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFlag3 = createReactComponent("flag-3", "IconFlag3", [
  ["path", { d: "M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16", key: "svg-0" }]
]);

export { IconFlag3 as default };
//# sourceMappingURL=IconFlag3.js.map
